export const agendaFiltersOtherUpdate = item => dispatch => {
	dispatch({
		type: 'AGENDA_FILTER_OTHER',
		item
	})
}